import React from 'react';

const FileFolderIcon = ({
  width = '15',
  height = '15',
  fill = 'none',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 15"
    fill={fill}
    {...props}
  >
    <g clipPath="url(#clip0_2642_1474)">
      <path
        d="M1.25081 13.0566L0.838567 5.88618C0.835033 5.81859 0.845379 5.751 0.868967 5.68757C0.892556 5.62414 0.928887 5.56621 0.975721 5.51736C1.02255 5.46851 1.0789 5.42976 1.14128 5.40352C1.20366 5.37728 1.27075 5.36409 1.33843 5.36477H5.91616C6.02686 5.36443 6.13453 5.40094 6.22217 5.46857C6.30982 5.53619 6.37246 5.63106 6.40022 5.73823L6.80528 7.51934H13.2675C13.3359 7.51878 13.4036 7.53235 13.4664 7.5592C13.5292 7.58606 13.5858 7.62562 13.6326 7.67539C13.6794 7.72516 13.7154 7.78408 13.7384 7.84844C13.7613 7.91279 13.7707 7.9812 13.766 8.04936L13.3767 13.0767C13.3554 13.3258 13.2409 13.5578 13.0562 13.7263C12.8714 13.8949 12.6299 13.9875 12.3799 13.9859H2.24909C1.99555 13.9875 1.75098 13.8922 1.5654 13.7195C1.37983 13.5467 1.26729 13.3096 1.25081 13.0566Z"
        stroke="#222222"
        strokeWidth="1.43638"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.71289 2.49497V1.77678C3.71289 1.58631 3.78856 1.40363 3.92324 1.26895C4.05793 1.13426 4.2406 1.05859 4.43108 1.05859H11.613C11.8034 1.05859 11.9861 1.13426 12.1208 1.26895C12.2555 1.40363 12.3312 1.58631 12.3312 1.77678V4.64954"
        stroke="#222222"
        strokeWidth="1.43638"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2642_1474">
        <rect
          width="14.3638"
          height="14.3638"
          fill="white"
          transform="translate(0.121094 0.340332)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default FileFolderIcon;
